import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Home } from "./pages/Home";
import { LegalPage } from "./pages/LegalPage";
import { ThanksPage } from "./pages/ThanksPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ScrollToTop } from "./components/ScrollToTop";
import { PauseBanner } from "./components/PauseBanner";

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <BrowserRouter>
                    <PauseBanner />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route
                            path="/mentions-legales-confidentialite"
                            element={<LegalPage />}
                        />
                        <Route path="/merci" element={<ThanksPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                    <ScrollToTop />
                </BrowserRouter>
            </HelmetProvider>
        </div>
    );
}

export default App;
